module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('span', {
    attrs: {
      "aria-label": "29",
      "epub:type": "pagebreak",
      "id": "page_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("PLAN FOR RETIREMENT AT ANY AGE")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-tit"
  }, [_c('b', [_vm._v("Are You On Track?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s frustrating trying to figure out whether or not you’re on track for a financially comfortable retirement. With so many different models you could use and dozens of variables to consider, it’s easy to get overwhelmed and put it off. The truth is, it’s not as difficult or discouraging as it seems—but it does involve a chunk of time and a little math. Then, you’ll do some periodic quick checks to make sure you stay on the right track.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("KNOW YOUR LIFE EXPECTANCY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the biggest question surrounding retirement savings is “How long do I need the money to last?” Unfortunately, there’s no definitive answer, but there are specific factors you can take into account to come up with a realistic estimate. That expected longevity will play an important part in your retirement plan projections. It will affect how much money you need overall, your safe withdrawal rate, and the best way to structure your retirement portfolio.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Start with the Average")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the Centers for Disease Control and Prevention (CDC), the average overall life expectancy in the US is 78.6 years. That number changes a little when you break it out by gender: The average lifespan for men is 76.1 and for women is 81.1.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "30",
      "epub:type": "pagebreak",
      "id": "page_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The numbers still look different if you look at life expectancy after age sixty-five. Overall, that number is 19.5 years; so someone who’s sixty-five now can expect to live until age eighty-four and a half. Gender makes a difference here too. Women age sixty-five and older have a life expectancy of 20.6 years, and men can expect an average 18.1 additional years.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Try a Life Expectancy Calculator")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are dozens of life expectancy calculators online that will give you a more tailored response than the CDC averages. They tend to ask a lot of the same questions (current age, blood pressure, exercise, smoking, etc.) but each has their own little twist. Since they’re free, you can try as many as you want to get a more complete picture of your life expectancy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here are some calculators (usually located in the “tools” menu) that aren’t super invasive and don’t make you hand over your email address:")]), _vm._v(" "), _c('ul', {
    staticClass: "blist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("How Long Will I Live? by Blueprint Income ("), _c('a', {
    attrs: {
      "href": "http://www.blueprintincome.com",
      "target": "_blank"
    }
  }, [_vm._v("www.blueprintincome.com")]), _vm._v(")")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Life Expectancy Calculator by Bankrate ("), _c('a', {
    attrs: {
      "href": "http://www.bankrate.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bankrate.com")]), _vm._v(")")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Life Span Calculator by Northwestern Mutual Life Insurance Company ("), _c('a', {
    attrs: {
      "href": "http://www.northwesternmutual.com",
      "target": "_blank"
    }
  }, [_vm._v("www.northwesternmutual.com")]), _vm._v(")")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Life Expectancy Calculator by John Hancock Life Insurance Company ("), _c('a', {
    attrs: {
      "href": "http://www.johnhancockinsurance.com",
      "target": "_blank"
    }
  }, [_vm._v("www.johnhancockinsurance.com")]), _vm._v(")")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("KNOW YOUR NEST EGG TARGET")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You’ll hear numbers like $500,000 or $1,000,000 thrown around a lot in the retirement planning world. Instead of going with "), _c('span', {
    attrs: {
      "aria-label": "31",
      "epub:type": "pagebreak",
      "id": "page_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("guesswork, take some time to come up with a number that works for your personal situation. A whole host of variables will factor into your retirement needs, from where you’ll live, to whether you’re supporting your children or parents, to the general state of your health. Figuring out your target nest egg will take a little time and some math. Once you have that, you can create a savings and investment plan that will get you there in plenty of time.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Make a Written Plan")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most people don’t have written retirement plans, and that can make it harder to keep retirement savings on track. Putting a plan in writing does the following:")]), _vm._v(" "), _c('ul', {
    staticClass: "blist"
  }, [_c('li', {
    staticClass: "bull"
  }, [_vm._v("Clarifies your goals and expectations")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Lets you know when you hit benchmarks")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Forces you to think about potential obstacles")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Involves some tax and estate planning")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Helps you refine your investment strategies")]), _vm._v(" "), _c('li', {
    staticClass: "bull"
  }, [_vm._v("Lets you come up with backup plans before you need them")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re not sure how to put all this together, think about consulting a fee-based financial advisor. They can help you create a flexible plan with a realistic retirement savings goal.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Set Your Target")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To set your target nest egg, think about how much money you’ll need to spend every year in retirement. Your expenses may be pretty close to the same or dramatically different (if you move to a different area, for example). Either way, you’ll need enough money to cover taxes and your basic known living expenses: housing, food, "), _c('span', {
    attrs: {
      "aria-label": "32",
      "epub:type": "pagebreak",
      "id": "page_32",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("transportation, healthcare premiums, etc. Plus, you’ll need money available to cover the fun stuff like dining out, travel, and entertainment. Adding all of that together will give you a rough idea of the annual “salary” you’ll need in retirement. Take that result and multiply it by 25 or 30 (years) to come up with a baseline estimate of the money you’ll need to stockpile in order to afford a comfortable retirement.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remember, this looks only at the expense side of your equation and doesn’t account for guaranteed income (such as Social Security retirement benefits) or strong investment returns.")]), _vm._v(" "), _c('p', {
    staticClass: "box-head"
  }, [_vm._v("Climate Change and Retirement Savings")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("Climate change appears to have a double-sided direct effect on retirement savings. On one side, younger generations have a more “why bother?” approach to savings, as they expect catastrophic climate consequences in their lifetimes. On the other side, few corporations and investment funds have changed their strategies or outlooks to respond to climate change, leading to inevitable financial losses that will directly impact many people’s retirement nest eggs through plummeting share prices and nonexistent dividends.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Don’t Get Sidetracked by Fear")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many conversations about retirement end up being discussions about fears and concerns. People are afraid they’ll outlive their money and be unable to afford their family’s basic needs. They worry about ending up in long-term care that forces them into bankruptcy. Fear of loss, isolation, declining health, and poverty colors what should be a golden, stress-free (or at least low-stress) time of life. Worrying about trying to save $1,000,000 can be unnerving and "), _c('span', {
    attrs: {
      "aria-label": "33",
      "epub:type": "pagebreak",
      "id": "page_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("make you feel like there’s no point in even trying. That negativity trap can convince you that you’ll never be able to save enough or that a comfortable retirement is hopeless.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Focusing on those scary what-ifs is paralyzing. Try to reframe the conversation to be about what a better retirement would look like. Look at the things you can start doing now to help counter those what-ifs. For example, if your biggest fear is going broke paying for a nursing home, look into long-term care insurance options, or start self-insuring by building up a sizeable HSA (health savings account). Address those fears, and turn them around before they disrupt your dream retirement.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e521f0a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781507212257/xhtml/ch02_sub01.vue
// module id = 87
// module chunks = 0